<div>
	<app-breadcrumbs></app-breadcrumbs>
</div>
<div class="product-status-container">
	@if (!loading()) {
		<app-table-form-container
			[loading]="loading()"
			[showForm]="isFormShowing()"
			modelName="Product Status"
			(onShowForm)="onShowForm()"
			(onHideForm)="onHideForm()"
		>
			<ng-template #tableTemplate>
				<app-cms-table
					[loading]="loading()"
					[rows]="productStatuses()"
					[columns]="columns()"
					(onEdit)="edit($event)"
					(onDelete)="delete$($event)"
					(onMoveUp)="moveUp$($event)"
					(onMoveDown)="moveDown$($event)"
				>
					<!-- Header templates (defines order/keys) -->
					<ng-template appHeaderColumn="status">Status</ng-template>
					<ng-template appHeaderColumn="productName">Product Name</ng-template>
					<ng-template appHeaderColumn="displayOrder">Display Order</ng-template>

					<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
					<ng-template appRowColumn="status" let-row>
						<div class="name-column clickable">
							{{ row.status }}
						</div>
					</ng-template>
					<ng-template appRowColumn="productName" let-row>
						<div class="name-column clickable">
							{{ row.product_name }}
						</div>
					</ng-template>
					<ng-template appRowColumn="displayOrder" let-row>
						<div class="name-column clickable">
							{{ row.display_order }}
						</div>
					</ng-template>
				</app-cms-table>
			</ng-template>

			<ng-template #formTemplate>
				<nz-card>
					<app-product-status-form
						[productStatus]="editProductStatus()"
						(onSubmit)="onProductStatusFormSubmit$($event)"
					></app-product-status-form>
				</nz-card>
			</ng-template>
		</app-table-form-container>
	}
</div>
